<template>
  <field-element :name="name" :label="label" :state="state" :type="'email'">
    <template v-slot:content>
      <input-email-element
          ref="input"
          :type="type"
          :id="name"
          :name="name"
          :value="value"
          :placeholder="placeholder"
          :minlength="minlength"
          :maxlength="maxlength"
          :pattern="pattern"
          :disabled="disabled"
          :required="required"
          :inputmode="inputmode"
          :lazy="lazy"
          @update:value="$emit('update:value', $event)"
      />
    </template>
  </field-element>
</template>

<script>
import fieldElement from '../../_shared/field.vue';
import fieldMixin from '../../_shared/fieldMixin';
import inputEmailElement from '../../../input/email/default/emailDefault.vue';

export default {
  name: 'emailFieldElement',
  components: {
    fieldElement,
    inputEmailElement
  },
  mixins: [
    fieldMixin
  ],
  props: {
    type: {
      type: String,
      default: () => 'text',
    },
    lazy: {
      type: Boolean,
      default: () => false,
    },
    inputmode: String,
    minlength: Number,
    maxlength: Number,
  },
};
</script>
